import GiriAbout from '@/components/custom/ui/clients/tempula/about/giriAbout'
import HomeAboutHero from '@/components/custom/ui/clients/tempula/homestay/homeAboutHero'
import HomestayFooterCmp from '@/components/custom/ui/clients/tempula/homestay/homestayFooter'
import aboutConfig from '@/constant/config/clients/tempula/about/aboutConfig'
import HomestayfooterConfig from '@/constant/config/clients/tempula/homestay/homestayFooterConfig'
import HomestayHeroConfig from '@/constant/config/clients/tempula/homestay/homestayHeroConfig'
import { createFileRoute } from '@tanstack/react-router'
import { SEO, buildPageHead } from '@/constant/config/clients/tempula/seo'

export const Route = createFileRoute('/_clients/tempula/aboutUs')({
    head: () => buildPageHead(SEO.about),
    component: RouteComponent,
})

function RouteComponent() {
  return (
  <div className="bg-BgGallery">
    <HomeAboutHero {...HomestayHeroConfig}/>
    <GiriAbout {...aboutConfig}/>
    <HomestayFooterCmp {...HomestayfooterConfig}/>
  </div>
  )
}
